import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'customer-details-partial',
  templateUrl: './customer-details-partial.component.html',
  styleUrls: ['./customer-details-partial.component.scss']
})
export class CustomerDetailsPartialComponent {
  @Input() multiOrder: any;
  @Input() showStartNewOrder = true;
  @Output() onStartNewOrderClick = new EventEmitter<void>();
}
